import { Card } from 'components/core-v2'
import { useEffect } from 'react'

import { ApiAssetPriceWithHistory } from '../../../api/rtk-api'
import { PriceOverride } from '../../../components/core-v2/organisms/price-override/price-override'
import { actions as rawActions } from '../state/gap-risk-slice'
import { useAppSelector } from '../store/hooks'
import { useActions } from '../store/use-actions'
import MarketDataStateless from '../templates/market-data-stateless'

export const MarketDataPage = () => {
  const state = useAppSelector(x => x.gapRisk)
  const actions = useActions(rawActions)

  const onPriceOverrideClick = (selectedAssetPrice: ApiAssetPriceWithHistory) => {
    actions.selectedAssetPrice(selectedAssetPrice)
  }

  useEffect(() => {
    if (!state.selectedAssetPrice?.isinCode) {
      return undefined
    }

    actions.refreshPriceOverrideDetail()
  }, [actions, state.selectedAssetPrice?.isinCode])

  return (
    <Card.Wrapper spacing="sm">
      <MarketDataStateless
        data={state.assetPrices}
        isLoading={state.isLoading}
        onPriceOverrideClick={onPriceOverrideClick}
      />

      {state.selectedAssetPrice && (
        <PriceOverride
          assetPriceWithHistory={state.selectedAssetPrice}
          errors={state.priceOverrideErrors}
          isLoadingOverrideAvailability={state.isCheckingPriceOverrideDetail}
          isSubmitting={state.isSubmittingPriceOverride}
          overrideInfo={state.priceOverrideInfo}
          readonly={state.areOverridesAllowed !== true}
          onClose={actions.stopPriceOverride}
          onPriceOverride={actions.onPriceOverride}
        />
      )}
    </Card.Wrapper>
  )
}
